import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from '../services/auth';

/**
 * '/dashboard' is a role dispatcher, not a page: admins land on the Admin Dashboard,
 * everyone else on the Partner Dashboard (the kycGuard still parks non-approved
 * partners on /partner-kyc when they get there). Every "go home" navigation in the
 * app can keep pointing at '/dashboard' — this guard picks the destination.
 *
 * On the server the role isn't knowable (no localStorage), so allow — the guards
 * re-run in the browser after hydration and the redirect happens there.
 */
export const dashboardRedirectGuard: CanActivateFn = (): boolean | UrlTree => {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) return true;
  const auth = inject(AuthService);
  const router = inject(Router);
  return router.parseUrl(auth.isAdmin() ? '/admin/dashboard' : '/partner-dashboard');
};
